export interface FileMeta {

  id: string;
  fileName: string;
  fileExt: string;
  byteCount: number;

  state: FileState;
  uploadUserId: string;
  uploadDateTime: Date;
  changeUserId: string;
  changeDateTime: Date;

}
export enum FileState {
  UPLOADED = 'UPLOADED',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
}
